$(document).ready(function() {
    $(".nav-menu-slider").on("click", function(e) {
        if ($(e.target).hasClass("show")) {
            $(e.target).removeClass("show");
        }
    });
});
